
var id = "uploadVideo";
var markup = "<symbol viewBox=\"0 0 38 38\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"uploadVideo\">\n    <title>icon/image/add_photo_alternate_24px</title>\n    <defs>\n        <path d=\"M113,66.0069493 L113,71.9911049 C113,71.9911049 109.02,72.0111188 109,71.9911049 L109,66.0069493 L103,66.0069493 C103,66.0069493 103.02,62.0241835 103,62.0041696 L109,62.0041696 L109,56 L113,56 L113,62.0041696 L119,62.0041696 L119,66.0069493 L113,66.0069493 Z M101,62 L101,68 L107,68 L107,74 L113,74 L113,90 C113,92.2 111.2,94 109,94 L109,94 L85,94 C82.8,94 81,92.2 81,90 L81,90 L81,66 C81,63.8 82.8,62 85,62 L85,62 L101,62 Z M93,70 L93,85 L103,77.5011998 L93,70 Z\" id=\"uploadVideo_path-1\" />\n    </defs>\n    <g id=\"uploadVideo_小程序素材管理\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"uploadVideo_小程序素材管理-编辑-视频\" transform=\"translate(-393.000000, -630.000000)\">\n            <g id=\"uploadVideo_区块-信息\" transform=\"translate(280.000000, 145.000000)\">\n                <g id=\"uploadVideo_视频图\" transform=\"translate(32.000000, 401.000000)\">\n                    <g id=\"uploadVideo_btn-详情图\" transform=\"translate(0.000000, 28.000000)\">\n                        <mask id=\"uploadVideo_mask-2\" fill=\"white\">\n                            <use xlink:href=\"#uploadVideo_path-1\" />\n                        </mask>\n                        <use id=\"uploadVideo_icon/image/add_photo_alternate_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#uploadVideo_path-1\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
